/**
 * @additionalProperties false
 */
export interface ListSelection {
    items: string[];
    selected: string;
}

export interface CustomFontSelection extends ListSelection {
    userLibraryFontName?: string;
    userLibraryFontUrl?: string;
    userLibraryFontUUID?: string;
}

export enum AnimationStyle {
    DEFAULT = "Default",
    ALTERNATIVE = "Alternative",
}

export enum TransitionStyle {
    FADE = "Fade",
    SLIDE_LEFT = "Slide left",
    FADE_AND_SLIDE_LEFT = "Fade & slide left",
    DIAGONALS = "Diagonals",
}

export enum InfoTextAnimationStyle {
  SHIFT_AWAY_SUBTLE = "Shift away subtle",
  SCALE_SUBTLE = "Scale subtle",
}

export enum TransitionSpeed {
    SLOW = "Slow",
    MEDIUM = "Medium",
    FAST = "Fast",
}

export interface TransitionStyleListSelection {
    items: TransitionStyle[];
    selected: TransitionStyle;
}

export interface AnimationStyleListSelection {
    items: AnimationStyle[];
    selected: AnimationStyle;
}

export interface TransitionSpeedListSelection {
    items: TransitionSpeed[];
    selected: TransitionSpeed;
}

export interface InfoTextAnimationStyleListSelection {
  items: InfoTextAnimationStyle[];
  selected: InfoTextAnimationStyle;
}

export enum ComplementaryTextSettings {
    IS_REVERSED = "isReversed",
    IS_FORMATTED_AS_PRICE = "isPrice",
    STATIC_TEXT = "text",
    COLUMN_CONTENT = "columnContent"
}

export enum Placement {
    RIGHT = "right",
    TOP = "top",
    BOTTOM = "bottom",
    LEFT = "left"
}

export enum PagesNavigationAction {
    SUBMIT = "submit",
    NEXT = "next",
    BACK = "back"
}
